import type { SxProps, Theme } from '@mui/material';

import { LOADER_LINEAR_Z_INDEX } from '@components/common/Loader/constants';

interface ILoaderStyles {
  isIframe: boolean;
}

interface ILoaderSxProperties {
  linearLoaderWrapperStyles: SxProps<Theme>;
  circularLoaderWrapperStyles: SxProps<Theme>;
}

export const sxProperties = ({
  isIframe,
}: ILoaderStyles): ILoaderSxProperties => ({
  circularLoaderWrapperStyles: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  linearLoaderWrapperStyles: {
    ...(isIframe ? { top: '0.313rem' } : { top: 0 }),
    left: 0,
    width: '100%',
    position: 'fixed',
    zIndex: LOADER_LINEAR_Z_INDEX,
    '& > * + *': {
      marginTop: '1rem',
    },
  },
});
